import AsyncComponent from '../../components/HOC/AsyncComponent';

const AsyncLoans = AsyncComponent(() => import('./AccountReceivable'));
const AsyncLateLoans = AsyncComponent(() => import('./LateAccountReceivable'));

export { AsyncLoans, AsyncLateLoans };



// WEBPACK FOOTER //
// ./src/pages/LoanModule/index.js